module.exports = __webpack_public_path__ + "static/media/slide3_mobile.fcf9fe5b.webp";